<template>
  <div>
    <!-- 디자인 시스템 AppSelect (테마 자동). 전역 auto-register -->
    <AppSelect v-bind="$attrs" :value="null" placeholder="상태 선택" :items="items" @change="onChange"></AppSelect>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // https://v2.vuetifyjs.com/en/components/selects/#custom-text-and-value
      // {text, value}
      // item-text="state", item-value="abbr"
      items: [
        { text: "해당없음", value: null },
        "방송준비 중",
        "밥먹고 올께요",
        "화장실...",
      ],
    };
  },
  methods: {
    onChange(value) {
      const isVisible = value === null ? false : true;
      const userInput = value === null ? null : value;
      this.$emit("change", isVisible, userInput);
    },
  },
};
</script>

<style></style>
